export * from './bill-of-material-update.component';